import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => {
  return {
    row: {
      display: "flex",
      alignItems: "end",
    },
    datePicker: {
      width: "55%",
    },
    timePicker: {
      width: "40%",
      marginLeft: "auto",
    },
  };
});
